<template>
  <div id="particulars">
    <!-- Form -->
    <el-button type="text" @click="dialogFormVisible = true">详情</el-button>

    <el-dialog title="电表详情" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="选择设备:">
          <el-select v-model="form.region" placeholder="请选择活动区域">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="尖电价(元):">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="告警金额(元):">
          <el-input v-model="form.popo" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="峰电价(元):">
          <el-input v-model="form.maxy" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="用电类型:" :label-width="formLabelWidth">
          <el-select v-model="form.desc" placeholder="请选择活动区域">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="平电价(元):">
          <el-input v-model="form.arr" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="初始金额(元):">
          <el-input v-model="form.initial" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="谷电价(元):">
          <el-input v-model="form.dali" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dps">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogFormVisible: false,
      form: {
        name: "",
        region: "",
        arr: "",
        desc: "",
        dali: "",
        initial: "",
        maxy: "",
        popo: "",
      },
      formLabelWidth: "120px",
    };
  },
  methods: {
    dps() {
      console.log(
        this.form.name,
        this.form.region,
        this.form.arr,
        this.form.desc,
        this.form.dali,
        this.form.initial,
        this.form.maxy,
        this.form.popo
      );
      this.dialogFormVisible = false;
    },
  },
};
</script>
<style lang="less" scoped>
</style>